import { debounce } from "@utils/utils.js";

let distanceScrolled = -1;
let distanceThreshold = [
  { threshold: 25, value: "25%", sent: false },
  { threshold: 50, value: "50%", sent: false },
  { threshold: 75, value: "75%", sent: false },
  { threshold: 100, value: "100%", sent: false },
];

const scrollDepth = () => {
  const scrollTop =
    document.body.scrollTop || document.documentElement.scrollTop;
  let progress = Math.round(
    (scrollTop / (document.body.scrollHeight - window.innerHeight)) * 100,
  );

  if (isNaN(progress)) progress = 0;

  if (progress > distanceScrolled) {
    distanceScrolled = progress;

    for (let i = 0; i < distanceThreshold.length; i++) {
      const status = distanceThreshold[i].sent;
      const threshold = distanceThreshold[i].threshold;
      const value = distanceThreshold[i].value;

      if (!status && progress >= threshold) {
        if ("dataLayer" in window) {
          window.dataLayer.push({
            event: "gatsbyScroll",
            gatsbyScrollDistance: value,
          });
          distanceThreshold[i].sent = true;
        }
      }
    }
  }
};

const scrollListener = debounce("scrollDepth", scrollDepth, 18);

const GTM = {
  init: () => {
    const interval = setInterval(() => {
      if ("dataLayer" in window && "google_tag_manager" in window) {
        window.dataLayer.push({ event: "gatsby-route-change" });
        clearInterval(interval);
      }
    }, 100);
    scrollDepth();
    document.addEventListener("scroll", scrollListener);

    // Event listener for when Osano consent is updated and saved
    // Add delay to ensure GTM is fully loaded before attaching listener
    setTimeout(() => {
      if (typeof window !== "undefined" && window.Osano && window.dataLayer) {
        window.Osano.cm.addEventListener("osano-cm-consent-saved", () => {
          window.dataLayer.push({
            event: "osano_consent_updated",
          });
        });
      }
    }, 1000); // Wait 1 second for GTM to fully initialize
  },
  // Modal
  handleModal: (showModal, modalType) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: showModal ? "interstitial_load" : "interstitial_dismiss",
        modalType,
      });
    }
  },
  // form tags START
  formSubmission: (formName) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({ event: "formCompletion", formName });
    }
  },
  formInputChange: (formName, fieldName, fieldValue) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "inputChange",
        formName,
        fieldName,
        fieldValue,
      });
    }
  },
  formFieldCompletionFormSubmitted: (formName, fieldName, fieldValue) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "formFieldCompletionFormSubmitted",
        formName,
        fieldName,
        fieldValue,
      });
    }
  },
  formInputError: (fieldName, fieldError, formName) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "inputError",
        fieldName,
        fieldError,
        formName,
      });
    }
  },
  errorPage: () => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "error_page_load",
      });
    }
  },
  // form tags END
  // video tags START
  videoPlay: (videoName) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "video_plays",
        event_action: videoName,
        event_label: "Start",
        full_url: window.location.href,
      });
    }
  },
  videoEnd: (videoName) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "video_plays",
        event_action: videoName,
        event_label: "End",
        full_url: window.location.href,
      });
    }
  },
  videoPercent: (videoName, percent) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "video_percent",
        event_action: videoName,
        event_label: `${percent}%`,
        full_url: window.location.href,
      });
    }
  },
  videoInterval: (videoName, seconds) => {
    if ("dataLayer" in window) {
      window.dataLayer.push({
        event: "video_interval_seconds",
        event_action: videoName,
        event_label: `${seconds}s`,
        full_url: window.location.href,
      });
    }
  },
  // video tags END
  reset: () => {
    distanceScrolled = -1;
    distanceThreshold.forEach((threshold) => (threshold.sent = false));
  },
};

export default GTM;
